var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngredients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02-harvest"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52 14v1.41a5.083 5.083 0 0 0 -4 0v-4.41h4z",
    fill: "#8ca52d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 15.41a5.093 5.093 0 0 0 -2 1.59 4.864 4.864 0 0 0 -2.78-2.74 3.2 3.2 0 0 1 2.78-1.26c1.66 0 2 .45 2 1z",
    fill: "#4a7017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.22 14.26a4.864 4.864 0 0 1 2.78 2.74 4.941 4.941 0 0 0 -1 3v9h-6.08l-1.87-9.73-.05-.27a5.279 5.279 0 0 1 1.26-3.54 4.446 4.446 0 0 1 3.39-1.46 4.616 4.616 0 0 1 1.57.26z",
    fill: "#679c20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.78 14.26a4.616 4.616 0 0 1 1.57-.26 4.446 4.446 0 0 1 3.39 1.46 5.279 5.279 0 0 1 1.26 3.54l-1.92 10h-6.08v-9a4.941 4.941 0 0 0 -1-3 4.864 4.864 0 0 1 2.78-2.74z",
    fill: "#679c20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.78 18.45a19.356 19.356 0 0 1 4.22-.45 19.926 19.926 0 0 1 4.22.44 16.6 16.6 0 0 1 2.78.84l.05-.01 1.87 9.73h-16.92v-4c0-.34 0-.68-.02-1a24.613 24.613 0 0 0 -.38-4.06 15.715 15.715 0 0 1 4.18-1.49z",
    fill: "#ff583e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 18a19.356 19.356 0 0 0 -4.22.45l-1.78-4.45 4 1.6 2-3.6 2 3.6 4-1.6-1.78 4.44a19.926 19.926 0 0 0 -4.22-.44z",
    fill: "#86c42b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 12a2.166 2.166 0 0 1 1-2c-2.21-.59-3-1.25-3-2s1-1 2-1c-.01-.01 1.01.01 1 0-1.31-1.91-.93-5 1-5a6.048 6.048 0 0 1 5 3v.09c-1.23-.94-2.38-1.35-2.82-.91-.56.56.24 2.28 1.8 3.84a10.136 10.136 0 0 0 1.02.89v.33a3.914 3.914 0 0 0 -3.33.27c-1.22.92-.73 2.78 1.11 4.16a4.563 4.563 0 0 0 .39.27 1.194 1.194 0 0 0 -.16.08l-.01-.02s-5 0-5-2z",
    fill: "#738c28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 8c0 .75-.79 1.41-3 2a2.166 2.166 0 0 1 1 2c0 2-5 2-5 2l-.01.02a1.194 1.194 0 0 0 -.16-.08 4.563 4.563 0 0 0 .39-.27c1.84-1.38 2.33-3.24 1.11-4.16a3.914 3.914 0 0 0 -3.33-.27v-.33a10.136 10.136 0 0 0 1.02-.89c1.56-1.56 2.36-3.28 1.8-3.84-.44-.44-1.59-.03-2.82.91v-.09a6.048 6.048 0 0 1 5-3c1.93 0 2.31 3.09 1 5-.01.01 1.01-.01 1 0 1 0 2 .25 2 1z",
    fill: "#8ca52d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 5.09c1.23-.94 2.38-1.35 2.82-.91.56.56-.24 2.28-1.8 3.84a10.136 10.136 0 0 1 -1.02.89v.33a3.914 3.914 0 0 1 3.33.27c1.22.92.73 2.78-1.11 4.16a4.563 4.563 0 0 1 -.39.27 10.49 10.49 0 0 0 -4.83-.94 10.49 10.49 0 0 0 -4.83.94 4.563 4.563 0 0 1 -.39-.27c-1.84-1.38-2.33-3.24-1.11-4.16a3.914 3.914 0 0 1 3.33-.27v-.33a10.136 10.136 0 0 1 -1.02-.89c-1.56-1.56-2.36-3.28-1.8-3.84.44-.44 1.59-.03 2.82.91v-1.09a3 3 0 0 1 6 0z",
    fill: "#c3dc4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.98 24c.02.32.02.66.02 1v4h-18v-4a25.012 25.012 0 0 1 .6-6c.64-2.52 1.77-4.08 3.41-4.98a1.194 1.194 0 0 1 .16-.08 10.49 10.49 0 0 1 4.83-.94 10.49 10.49 0 0 1 4.83.94 1.194 1.194 0 0 1 .16.08c1.83 1 3.04 2.84 3.61 5.92a24.613 24.613 0 0 1 .38 4.06z",
    fill: "#ff942c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 59h6v4h-6z",
    fill: "#a56645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 59h6v4h-6z",
    fill: "#a56645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 49h14v10h-29a2.006 2.006 0 0 1 -2-2v-6a2.006 2.006 0 0 1 2-2z",
    fill: "#c7874e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 59h-28v-10h29a2.006 2.006 0 0 1 2 2v6a2.006 2.006 0 0 1 -2 2z",
    fill: "#d99c64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 39h15a2.006 2.006 0 0 1 2 2v6a2.006 2.006 0 0 1 -2 2h-15z",
    fill: "#c7874e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 39h14 14v10h-14-14z",
    fill: "#d99c64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 49h-15a2.006 2.006 0 0 1 -2-2v-6a2.006 2.006 0 0 1 2-2h15z",
    fill: "#c7874e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 29h29v10h-29a2.006 2.006 0 0 1 -2-2v-6a2.006 2.006 0 0 1 2-2z",
    fill: "#c7874e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 39h-14v-10h29a2.006 2.006 0 0 1 2 2v6a2.006 2.006 0 0 1 -2 2z",
    fill: "#d99c64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 15a5 5 0 0 1 5 5v9a0 0 0 0 1 0 0h-10a0 0 0 0 1 0 0v-9a5 5 0 0 1 5-5z",
    fill: "#93d632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 17a4.864 4.864 0 0 1 2.78-2.74 3.2 3.2 0 0 0 -2.78-1.26c-1.66 0-2 .45-2 1v1.41l.087.06a4.989 4.989 0 0 1 1.4.951l.057.039a4.691 4.691 0 0 1 .456.54z",
    fill: "#4a7017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 39h-15v2h14a1 1 0 0 1 1 1v7a2.006 2.006 0 0 0 2-2v-6a2.006 2.006 0 0 0 -2-2z",
    fill: "#d99c64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 46v-5h-2v8h15v-2h-12a1 1 0 0 1 -1-1z",
    fill: "#b37036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 29h-29v2h28a1 1 0 0 1 1 1v7a2.006 2.006 0 0 0 2-2v-6a2.006 2.006 0 0 0 -2-2z",
    fill: "#e9b789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 29h29v2h-28a1 1 0 0 0 -1 1v7a2.006 2.006 0 0 1 -2-2v-6a2.006 2.006 0 0 1 2-2z",
    fill: "#d99c64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 37h-13a1 1 0 0 1 -1-1v-5h-2v8h29v-2z",
    fill: "#c7874e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 31v5a1 1 0 0 1 -1 1h-26v2h29v-8z",
    fill: "#b37036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 49h-29v2h28a1 1 0 0 1 1 1v7a2.006 2.006 0 0 0 2-2v-6a2.006 2.006 0 0 0 -2-2z",
    fill: "#e9aa70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 49h29v2h-28a1 1 0 0 0 -1 1v7a2.006 2.006 0 0 1 -2-2v-6a2.006 2.006 0 0 1 2-2z",
    fill: "#d99c64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 57h-13a1 1 0 0 1 -1-1v-5h-2v8h29v-2z",
    fill: "#c7874e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 51v5a1 1 0 0 1 -1 1h-26v2h29v-8z",
    fill: "#b37036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 47h28v2h-28z",
    fill: "#c7874e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 39v8h2v-5a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v5h2v-8z",
    fill: "#e9b789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 39h15v2h-14a1 1 0 0 0 -1 1v7a2.006 2.006 0 0 1 -2-2v-6a2.006 2.006 0 0 1 2-2z",
    fill: "#d99c64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 46v-5h2v8h-15v-2h12a1 1 0 0 0 1-1z",
    fill: "#b37036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 63v-1a1 1 0 0 1 1-1h2v-2h-6v4z",
    fill: "#714226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 63v-1a1 1 0 0 1 1-1h2v-2h-6v4z",
    fill: "#714226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 21v-6.276a7.936 7.936 0 0 0 -2.4 4.276 25.012 25.012 0 0 0 -.6 6v4h18v-4h-11a4 4 0 0 1 -4-4z",
    fill: "#fe792c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.83 14.94a1.194 1.194 0 0 1 .16.08c1.83 1 3.04 2.84 3.61 5.92a24.613 24.613 0 0 1 .38 4.06h3.02c0-.34 0-.68-.02-1a24.613 24.613 0 0 0 -.38-4.06c-.57-3.08-1.78-4.92-3.61-5.92a1.194 1.194 0 0 0 -.16-.08 10.49 10.49 0 0 0 -4.83-.94 10.49 10.49 0 0 0 -4.83.94 1.194 1.194 0 0 0 -.16.08c-.079.043-.151.1-.228.142a15.056 15.056 0 0 1 2.218-.162 10.49 10.49 0 0 1 4.83.94z",
    fill: "#ffb844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.33 9.51a3.914 3.914 0 0 0 -3.33-.27v-.33a10.136 10.136 0 0 0 1.02-.89c1.56-1.56 2.36-3.28 1.8-3.84-.44-.44-1.59-.03-2.82.91v-1.09a3 3 0 0 0 -3-3v12a10.49 10.49 0 0 1 4.83.94 4.563 4.563 0 0 0 .39-.27c1.84-1.38 2.33-3.24 1.11-4.16z",
    fill: "#d2eb5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 15.41a5.083 5.083 0 0 1 4 0v-1.988a4.95 4.95 0 0 0 -4 0z",
    fill: "#738c28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 27a2 2 0 0 1 -2-2v-8.977a4.974 4.974 0 0 0 -2 3.977v9h10v-2z",
    fill: "#86c42b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 15a4.954 4.954 0 0 0 -3.149 1.145h.006c.049-.04.093-.084.143-.121v.076a5 5 0 0 1 6 4.9v6h2v-7a5 5 0 0 0 -5-5z",
    fill: "#a7e340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.076 25.811.924-4.811a5.279 5.279 0 0 0 -1.26-3.54 4.422 4.422 0 0 0 -3.184-1.439 6.176 6.176 0 0 0 -.556.979c.029.038.05.083.078.122.055.078.1.159.154.241a4.881 4.881 0 0 1 .3.556c.039.085.077.17.111.258a4.825 4.825 0 0 1 .2.635c.02.085.046.167.063.253a5.041 5.041 0 0 1 .094.935v9h6.08l.384-2h-2.406a1 1 0 0 1 -.982-1.189z",
    fill: "#5b8a1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.924 25.811-.924-4.811a5.279 5.279 0 0 1 1.26-3.54 4.422 4.422 0 0 1 3.184-1.439 6.176 6.176 0 0 1 .556.979c-.029.038-.05.083-.078.122-.055.078-.1.159-.154.241a4.881 4.881 0 0 0 -.3.556c-.039.085-.077.17-.111.258a4.793 4.793 0 0 0 -.2.636c-.02.084-.046.166-.063.252a5.041 5.041 0 0 0 -.094.935v9h-6.08l-.384-2h2.406a1 1 0 0 0 .982-1.189z",
    fill: "#5b8a1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.05 19.27-.05.01a16.754 16.754 0 0 0 -2.708-.822l1.23 6.15a2 2 0 0 1 -1.962 2.392h-6.56a2 2 0 0 1 -2-2v-6.361a15.634 15.634 0 0 0 -3.4 1.3 24.613 24.613 0 0 1 .38 4.061c.02.32.02.66.02 1v4h16.92z",
    fill: "#db0404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 15.6-4-1.6 1.78 4.45a19.356 19.356 0 0 1 4.22-.45v-6z",
    fill: "#679c20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 32,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 32,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 36,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 42,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 46,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 42,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 46,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 46,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 52,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 56,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 52,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 56,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 42,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 46,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 52,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 56,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 52,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 56,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 32,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 36,
    fill: "#845335",
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#714226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59 32a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 36a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 32a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 36a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 42a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 46a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 42a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 46a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 42a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 46a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 42a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 46a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 32a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 36a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 32a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 36a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 52a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 56a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 52a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 56a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 52a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 56a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 52a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 56a.986.986 0 0 1 -.847-.5.977.977 0 0 0 -.153.5 1 1 0 0 0 2 0 .977.977 0 0 0 -.153-.5.986.986 0 0 1 -.847.5z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.684,
    cy: 18.695,
    fill: "#f6fafd",
    rx: 1.642,
    ry: 2.286,
    transform: "matrix(.707 -.707 .707 .707 1.927 42.039)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.682,
    cy: 22.708,
    fill: "#f6fafd",
    rx: 0.825,
    ry: 1.148,
    transform: "matrix(.707 -.707 .707 .707 -.62 43.921)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.682,
    cy: 17.708,
    fill: "#f6fafd",
    rx: 0.825,
    ry: 1.148,
    transform: "matrix(.707 -.707 .707 .707 -7.05 18.405)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.682,
    cy: 20.708,
    fill: "#f6fafd",
    rx: 0.825,
    ry: 1.148,
    transform: "matrix(.707 -.707 .707 .707 -5.068 29.188)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.682,
    cy: 17.708,
    fill: "#f6fafd",
    rx: 0.825,
    ry: 1.148,
    transform: "matrix(.707 -.707 .707 .707 5.262 48.114)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.427,
    cy: 20.208,
    fill: "#f6fafd",
    rx: 0.413,
    ry: 0.574,
    transform: "matrix(.707 -.707 .707 .707 -5.375 27.447)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.427,
    cy: 20.208,
    fill: "#f6fafd",
    rx: 0.413,
    ry: 0.574,
    transform: "matrix(.707 -.707 .707 .707 -8.599 19.666)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c7874e",
    height: 2,
    rx: 1,
    width: 8,
    x: 42,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d99c64",
    height: 2,
    rx: 1,
    width: 8,
    x: 16.102,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e9aa70",
    height: 2,
    rx: 1,
    width: 8,
    x: 29,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c7874e",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 38,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c7874e",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 51,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c7874e",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 53,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2cfa9",
    height: 2,
    rx: 1,
    width: 14,
    x: 41,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2cfa9",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 56,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2cfa9",
    height: 2,
    rx: 1,
    width: 14,
    x: 23,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2cfa9",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 38,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d99c64",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 12,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#b37036",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 8,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d99c64",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 57,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e9aa70",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 25,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#b37036",
    height: 2,
    rx: 1,
    width: 8,
    x: 7,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d99c64",
    height: 2,
    rx: 1,
    width: 6,
    x: 20,
    y: 54
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c7874e",
    height: 2,
    rx: 1,
    width: 6,
    x: 38,
    y: 54
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c7874e",
    height: 2,
    rx: 1,
    width: 6,
    x: 46,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#b37036",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 16,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4700c",
    height: 2,
    rx: 1,
    width: 8,
    x: 5,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4700c",
    height: 2,
    rx: 1,
    width: 4,
    x: 15,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e66718",
    height: 2,
    rx: 1,
    width: 8,
    x: 5,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4700c",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 15,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4700c",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 11,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e66718",
    height: 2,
    rx: 0.977,
    width: 3,
    x: 14,
    y: 27
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredients);
export default __webpack_public_path__ + "static/media/ingredients.e9803426.svg";
export { ForwardRef as ReactComponent };